import { useEffect, useState } from "react";
import { BRAND } from "@core/brand/brand-config";
import { Search } from "react-feather";
import LoaderImg from "@assets/images/loader.gif";
import { UserOnboardingData } from "./enum";
import Supademo from "./Supademo";

const TrademoTrainingSessions = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  };

  const highlightText = (text, highlight) => {
    if (!highlight) return text;
    const escapedHighlight = escapeRegExp(highlight);
    const parts = text.split(new RegExp(`(${escapedHighlight})`, "gi"));
    return parts.map((part, index) => {
      const key = `${index}-${part}-${highlight}`;
      return part.toLowerCase() === highlight.toLowerCase() ? (
        <span key={key} className="tw-bg-yellow-200 tw-font-semibold">
          {part}
        </span>
      ) : (
        <span key={key}>{part}</span>
      );
    });
  };

  const handleItemClick = (item) => {
    setSelectedItem(item);
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
    setSelectedItem(null);
  };

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  const filteredTrainingSessionsData = Object.values(UserOnboardingData.onboarding_details).filter((item) => item.title.toLowerCase().includes(searchTerm?.toLowerCase() ?? ""));

  return (
    <div className="tw-flex tw-flex-col tw-bg-gray-25 tw-gap-[28px] tw-h-[calc(100vh-48px)] tw-items-center">
      <div className="tw-flex tw-flex-col tw-items-center tw-mt-5 ">
        <div className="tw-text-base tw-font-medium">What's new in {BRAND.shortName}</div>
        <div className="tw-text-xs tw-text-gray-500 tw-mt-2">Latest Enhancements & Features in {BRAND.name}</div>
        <div className="tw-flex tw-items-center tw-relative tw-border tw-border-gray-200 tw-rounded-full tw-px-3 tw-py-2 tw-mt-2 tw-min-w-[460px] tw-shadow-button tw-bg-white">
          <Search size={14} color="#101828" className="" />
          <input type="text" className="tw-w-full tw-py-0.5 tw-rounded-lg tw-pl-3 tw-outline-none" placeholder={`Type to find new updates`} value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
        </div>
      </div>
      {loading ? (
        <div className="loader-container">
          <div className="loader-block">
            <img src={LoaderImg} alt="description of gif" />
          </div>
        </div>
      ) : (
        <div className="tw-w-full tw-max-w-6xl tw-px-8">
          {filteredTrainingSessionsData.length > 0 ? (
            filteredTrainingSessionsData.map((item, index) => (
              <div key={item.key} className="tw-mb-8">
                <div className="tw-flex tw-flex-row tw-gap-8 tw-items-start">
                  {/* Left side - Image/Demo */}
                  <div className="tw-flex tw-basis-1/2 tw-justify-center">
                    <div className="tw-relative tw-w-[340px] tw-h-[200px] tw-rounded-md tw-shadow-xl tw-overflow-hidden tw-bg-gradient-to-br tw-from-purple-600 tw-to-purple-800 tw-cursor-pointer" onClick={() => handleItemClick(item)}>
                      {item.isNew && <div className="tw-absolute tw-top-3 tw-left-3 tw-bg-white tw-text-purple-700 tw-px-2 tw-py-1 tw-rounded tw-text-xs tw-font-semibold tw-z-10">New</div>}
                      <div className="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center">
                        <img src={item.image} alt={item.title} className="tw-w-full tw-h-full tw-object-cover" />
                      </div>
                      <div className="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-black tw-bg-opacity-20 tw-opacity-100 tw-transition-opacity tw-cursor-pointer">
                        <div className="tw-w-12 tw-h-12 tw-bg-white tw-bg-opacity-90 tw-rounded-full tw-flex tw-items-center tw-justify-center">
                          <svg className="tw-w-5 tw-h-5 tw-text-purple-700 tw-ml-1" fill="currentColor" viewBox="0 0 20 20">
                            <path d="M6.3 2.841A1.5 1.5 0 004 4.11V15.89a1.5 1.5 0 002.3 1.269l9.344-5.89a1.5 1.5 0 000-2.538L6.3 2.84z" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Right side - Title/Brief */}
                  <div className="tw-flex tw-basis-1/2 tw-flex-col tw-py-4">
                    <h4 className="tw-text-lg tw-font-semibold tw-text-gray-900 tw-mb-3">{highlightText(item.title, searchTerm.trim())}</h4>
                    <p className="tw-text-sm tw-text-gray-600 tw-leading-relaxed">{item.brief}</p>
                  </div>
                </div>
                {index !== filteredTrainingSessionsData.length - 1 && <hr className="tw-mt-8 tw-border-gray-200" />}
              </div>
            ))
          ) : (
            <div className="tw-px-6 tw-py-8 tw-bg-white tw-rounded-lg tw-text-center tw-text-gray-500 tw-shadow-sm">
              <div className="tw-mb-2">
                <Search size={24} className="tw-mx-auto tw-text-gray-300" />
              </div>
              <p className="tw-text-sm">No Training Session Videos found matching your search.</p>
            </div>
          )}
        </div>
      )}
      {isOpen && selectedItem && <Supademo type="modal" url={selectedItem.supademoUrl} modalHeading={selectedItem.title} description={selectedItem.brief} closeModal={handleClose} />}
    </div>
  );
};

export default TrademoTrainingSessions;
